import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";

Scrivito.provideEditingConfig("EventWidget", {
  title: "Event Widget",
  attributes: localizeAttrList(["destination"], "EventWidget"),
  properties: ["destination"],
  initialContent: {
    color: "blue",
    headline: "Lorem Ipsum",
  },
});
